<template>
  <page>
    <div class="flex column">
      <div class="mt-4 mx-4 mb4 border_radius_top flex column">
        <!-- setting width in the style, so aspect ratio stays the same-->
        <edit-image
          v-model="organization.image.url"
          :callback="setUrlToOrganization"
          :height="350"
          :width="350"
          :pixel-density="1"
          show-camera-icon
          style="width: 100%"
        />
      </div>

        <input
          style="text-align: left;"
          class="box grow"
          id="name"
          name="name"
          v-validate="'required'"
          v-model="organization.name"
          type="text"
          :placeholder="$t('cms.editOrganization.NameInput')"
          :class="{ 'error': errors.has('name') }"
        >
      <span v-if="errors.has('name')" class="error">{{ errors.first('name') }}</span>

        <input
          style="text-align: left;"
          class="box grow"
          id="subtitle"
          name="subtitle"
          v-validate="'required'"
          v-model="organization.subtitle"
          type="text"
          :placeholder="$t('cms.editOrganization.SubtitleInput')"
          :class="{ 'error': errors.has('subtitle') }"
        >
      <span v-if="errors.has('subtitle')" class="error">{{ errors.first('subtitle') }}</span>


      <input
        style="text-align: left;"
        v-model="organization.city"
        name="city"
        :placeholder="$t('cms.editOrganization.CityPlaceholder')"
        v-validate="'required'"
        class="flex grow box my1"
      >
      <span v-if="errors.has('city')" class="error">{{ errors.first('city') }}</span>

      <input
        style="text-align: left;"
        v-model="organization.streetAddress"
        name="streetAddress"
        :placeholder="$t('cms.editOrganization.StreetAddressPlaceholder')"
        v-validate="'required'"
        class="flex grow box my1"
      >
      <span v-if="errors.has('streetAddress')" class="error">
        {{ errors.first('streetAddress') }}
      </span>

      <input
        style="text-align: left;"
        v-model="organization.postcode"
        name="postcode"
        :placeholder="$t('cms.editOrganization.PostcodePlaceholder')"
        v-validate="'required'"
        class="flex grow box my1"
      >
      <span v-if="errors.has('postcode')" class="error">{{ errors.first('postcode') }}</span>

      <timezone-select v-model="organization.timezone"/>

      <country-select v-model="organization.country"/>

      <currency-select v-model="currency"/>

      <input
        style="text-align: left;"
        type="email"
        :value="organization.email"
        class="flex grow box my1 disabled-input"
        disabled
      >
      <span v-if="errors.has('email')" class="error">{{ errors.first('email') }}</span>

      <button
        class="box primary maximize_width my1"
        :disabled="disabledSave"
        @click="saveOrganization"
        name="saveorganization"
      >
        {{ $t('cms.editOrganization.SaveButton') }}
      </button>
    </div>
  </page>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import store from '../store';
import EditImage from '@/components/EditImage.vue';
import CurrencySelect from '@/components/CurrencySelect.vue';
import CountrySelect from '@/components/CountrySelect.vue';
import TimezoneSelect from '@/components/TimezoneSelect.vue';
import { objectIsDifferent } from '@/utils/difference';

export default {
  name: 'edit-organization',

  components: {
    CurrencySelect, CountrySelect, TimezoneSelect, EditImage,
  },

  data() {
    return {
      organization: store.state.organization,
      savedOrganization: cloneDeep(store.state.organization),
      currency: store.state.organization.currency.id,
      imageInput: null,
    };
  },

  computed: {
    isFormChanged() {
      return objectIsDifferent(this.organization, this.savedOrganization)
        || this.currency !== this.savedOrganization.currency.id;
    },

    // doesn't check for country, currency and timezone
    isComplete() {
      return this.organization.subtitle
        && this.organization.name
        && this.organization.city
        && this.organization.streetAddress
        && this.organization.postcode;
    },

    disabledSave() {
      return !this.isComplete || !this.isFormChanged;
    },
  },

  methods: {
    setUrlToOrganization(url) {
      this.imageInput = {
        url,
        imageOfOrganization: this.organization.id,
        ownedByOrganization: this.organization.id,
      };
    },

    saveUrlToOrganization() {
      if (this.imageInput) {
        this.$mutate(this.$mutations.createImage, { input: this.imageInput });
      }
    },

    saveOrganization: async function save() {
      if (!await this.$validator.validate()) { return; }

      const input = {
        id: this.organization.id,
        subtitle: this.organization.subtitle,
        name: this.organization.name,
        timezone: this.organization.timezone,
        city: this.organization.city,
        streetAddress: this.organization.streetAddress,
        postcode: this.organization.postcode,
        country: this.organization.country,
        currency: this.currency,
      };
      const mutation = this.$mutations.editOrganization;
      const { data, errors } = await this.$mutate(mutation, { input });
      const organization = get(data, 'updateOrganization.organization');

      if (organization) {
        store.state.organization = Object.assign(
          store.state.organization,
          { ...organization, address: `${organization.country} ${organization.city} ${organization.streetAddress}` },
        );
        this.savedOrganization = cloneDeep(this.organization);
        this.saveUrlToOrganization();
      } else {
        this.handleErrors(errors);
      }
    },
  },
};
</script>
